module.exports = __webpack_public_path__ + "img/maneken_pos_6.e2e98410.png";